import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
  Paper,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import Loader3D from '../../components/Loader/Loader3D';
import GlobalSelectField from '../../components/mui/GlobalSelectField';
import RefundCalculation from './RefundCalculation';
import { Icon } from '@iconify/react/dist/iconify.js';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import RequestInfo from './RequestInfo';
import FetchedStudentDetails from './FetchedStudentDetails';
import {
  getRefundCalculation,
  getStudentDetails,
  postChangeStatus,
  postEnrolledScheduleDateFinance,
} from '../../redux/features/refundSlice';
import GlobalViewAttachment from '../../components/Fileupload/GlobalViewAttachment';
import { rejectionReasons } from '../../utils/constants/rejectionReasonJson';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';
import { crmTypes, croTypeNames, ogaTypeNames, sogoTypes } from '../../utils/employeeTypes';
import GlobalAllTypeFileView from '../../components/Fileupload/GlobalAllTypeFileView';

const status = [
  { id: 1, name: 'Approve' },
  { id: 2, name: 'Reject' },
];

const action = ['verify', 'approval', 'finance', 'pm'];
const GlobalRefundApprovalReject = ({ open, setOpen, rowData, dispatchParams, action, apiDispatchAfterSuccess }) => {
  const [hasActions, setHasActions] = useState(Boolean(action));
  const { loading, studentData, submitionLoading, refundCalculation, additionalLoading } = useSelector(
    (state) => state.refund,
  );
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const apiHandler = useHandleApiResponse();

  const EXPENSE_ID = rowData?.expense_id;
  useEffect(() => {
    if (open) {
      dispatch(
        getStudentDetails({
          course_enrollment_id: rowData?.expense_course_enrollment_id,
          subject_enrollment_id: rowData?.subject_enrollment_id,
        }),
      );
      dispatch(
        getRefundCalculation({
          course_enrollment_id: rowData?.expense_course_enrollment_id,
          subject_enrollment_id: rowData?.subject_enrollment_id,
          refund_request_date: rowData?.parent_requested_date?.split(' ')[0],
        }),
      );
    }
  }, [open]);

  const initialValues = {
    status: '',
    remarks: '',
    scheduled_payment_date: '',
    accountant_rejected_reason_id: '',
  };

  const schema = Yup.object({
    status: Yup.string().required('Status is required'),
    remarks: Yup.string().when('status', {
      is: (val) => val === '2',
      then: (schema) => schema.required('Remarks are required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    scheduled_payment_date: Yup.date().when('status', {
      is: (val) => val === '1' && action === 'finance',
      then: (schema) => schema.required('Scheduled Payment Date is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    accountant_rejected_reason_id: Yup.string().when('status', {
      is: (val) => val === '2' && action === 'finance',
      then: (schema) => schema.required('Rejection Reason is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    // onSubmit: (values) => {
    //   // dispatch the approval/rejection action here
    //   if (action === 'finance') {
    //     if (values.status === 1) {
    //       //approve
    //       dispatch(
    //         postEnrolledScheduleDateFinance({
    //           expense_id: EXPENSE_ID,
    //           schedule_date: values.scheduled_payment_date,
    //         })
    //       )
    //         .unwrap()
    //         .then((res) => {
    //           dispatch(postChangeStatus({ ...values, type: action, expense_id: EXPENSE_ID })).then((res) =>
    //             apiHandler(res, {
    //               onSuccess: () => setOpen(false),
    //             })
    //           );
    //         });
    //     } else {
    //       //all other
    //       dispatch(postChangeStatus({ ...values, type: action, expense_id: EXPENSE_ID })).then((res) =>
    //         apiHandler(res, {
    //           onSuccess: () => setOpen(false),
    //         })
    //       );
    //     }
    //   } else if (action == 'verify' || action == 'approval') {
    //     const role = profile?.role;
    //     const sogoTypes = ['Senior Operations Growth Officer'];
    //     const type = sogoTypes.includes(role) ? 'sogo' : 'crm';
    //     dispatch(
    //       postChangeStatus({ status: values.status, type: type, expense_id: EXPENSE_ID, remarks: values.remarks })
    //     ).then((res) =>
    //       apiHandler(res, {
    //         onSuccess: () => setOpen(false),
    //       })
    //     );
    //   } else if (action == 'pm') {
    //     dispatch(
    //       postChangeStatus({ status: values.status, type: 'pm', expense_id: EXPENSE_ID, remarks: values.remarks })
    //     ).then((res) =>
    //       apiHandler(res, {
    //         onSuccess: () => setOpen(false),
    //       })
    //     );
    //   }
    //   dispatch(apiDispatchAfterSuccess(dispatchParams));
    // },
    onSubmit: async (values) => {
      try {
        if (action === 'finance') {
          if (values.status === 1) {
            // approve
            await dispatch(
              postEnrolledScheduleDateFinance({
                expense_id: EXPENSE_ID,
                schedule_date: values.scheduled_payment_date,
              }),
            ).unwrap();

            const res = await dispatch(
              postChangeStatus({
                ...values,
                type: action,
                expense_id: EXPENSE_ID,
                accountant_rejected_reason_id: values.accountant_rejected_reason_id || null,
              }),
            );
            apiHandler(res, { onSuccess: () => setOpen(false) });
          } else {
            // all other
            const res = await dispatch(
              postChangeStatus({
                ...values,
                type: action,
                expense_id: EXPENSE_ID,
                accountant_rejected_reason_id: values.accountant_rejected_reason_id || null,
              }),
            );
            apiHandler(res, { onSuccess: () => setOpen(false) });
          }
        } else if (action === 'verify' || action === 'approval') {
          const role = profile?.role;
          const sogoTypes = ['Senior Operations Growth Officer'];
          const type = sogoTypes.includes(role) ? 'sogo' : 'crm';

          const res = await dispatch(
            postChangeStatus({
              status: values.status,
              type,
              expense_id: EXPENSE_ID,
              remarks: values.remarks,
              status_type: action,
            }),
          );
          apiHandler(res, { onSuccess: () => setOpen(false) });
        } else if (action === 'pm') {
          const res = await dispatch(
            postChangeStatus({
              status: values.status,
              type: 'pm',
              expense_id: EXPENSE_ID,
              remarks: values.remarks,
              status_type: action,
            }),
          );
          apiHandler(res, { onSuccess: () => setOpen(false) });
        }

        await dispatch(apiDispatchAfterSuccess(dispatchParams));
      } catch (error) {
        console.log('Error: ', error);
      }
    },
  });

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const attachments = [
    { name: 'Date Request Attachement', url: '/files/receipt.pdf' },
    { name: 'Other', url: '/files/receipt.pdf' },
  ];

  /* const rejectedReasons = [
    { id: 1, name: 'Missing Documentation' },
    { id: 2, name: 'Policy Violation' },
    { id: 3, name: 'Other' },
  ]; */

  const submitDisablingFunction = () => {
    // const croTypeNames = [
    //   'client relations officer',
    //   'client relations associate',
    //   'client relation officer',
    //   'associate academic mentor',
    // ];

    // const ogaTypeNames = [
    //   'operations growth associate',
    //   'operations growth trainee',
    //   'operations growth associate trainee',
    // ];
    const requestedByCro = croTypeNames.includes(rowData?.raisedByUserType?.toLowerCase());
    const requestedByOga = ogaTypeNames.includes(rowData?.raisedByUserType?.toLowerCase());

    //const crmTypes = ['client relations manager', 'senior client relations officer', 'senior program officer'];
    //   const sogoTypes = ['senior operations growth officer'];
    // const loginedBySogo = sogoTypes.includes(profile?.role?.toLowerCase());
    // const loginedByCrm = crmTypes.includes(profile?.role?.toLowerCase());
    const loginedBySogo = sogoTypes.some((type) => profile?.role?.toLowerCase()?.includes(type));
    const loginedByCrm = crmTypes.some((type) => profile?.role?.toLowerCase()?.includes(type));

    const isOgaRelated = rowData?.parent_reason == 'OGA Related';
    const isCroRelated = rowData?.parent_reason == 'CRO Related';
    console.log({
      actionType: action,
      isOgaRelated,
      isCroRelated,
      loginedBySogo,
      loginedByCrm,
      requestedByCro,
      requestedByOga,
      profileRole: profile?.role,
    });

    if (action === 'verify') {
      return Boolean(
        rowData?.cro_verification ||
        rowData?.sogo_verification ||
        rowData?.expense_crm_approval ||
        rowData?.expense_accountant_approval,
      );
    } else if (action === 'approval') {
      if (rowData?.expense_crm_approval || rowData?.expense_accountant_approval) {
        return true;
      }

      if (loginedBySogo) {
        return isOgaRelated
          ? Boolean(rowData?.sogo_verification)
          : isCroRelated
            ? rowData?.cro_verification != 1 || Boolean(rowData?.sogo_verification)
            : Boolean(rowData?.sogo_verification);
      } else if (loginedByCrm) {
        //logined by CRM
        return isCroRelated
          ? Boolean(rowData?.cro_verification)
          : isOgaRelated
            ? rowData?.sogo_verification != 1 || Boolean(rowData?.cro_verification)
            : Boolean(rowData?.cro_verification);
      } else {
        console.log('Logined role is', profile?.role);
        console.log('issue is related with', rowData?.parent_reason);
        return true;
      }
    } else if (action === 'pm') {
      if (rowData?.expense_crm_approval || rowData?.expense_accountant_approval) {
        return true;
      }
      if (isOgaRelated) {
        return isOgaRelated && requestedByOga
          ? rowData?.sogo_verification != 1
          : rowData?.sogo_verification != 1 || rowData?.cro_verification != 1;
      } else if (isCroRelated) {
        return isCroRelated && requestedByCro
          ? rowData?.cro_verification != 1
          : rowData?.sogo_verification != 1 || rowData?.cro_verification != 1;
      } else if (!isCroRelated && !isOgaRelated) {
        //NEWLY ADDED CONDTION
        if (requestedByCro) {
          return rowData?.cro_verification != 1;
        } else if (requestedByOga) {
          return rowData?.sogo_verification != 1;
        }
      } else {
        return false;
      }
    } else if (action === 'finance') {
      return rowData?.expense_crm_approval != 1 || rowData?.expense_accountant_approval == 1;
    }
    console.log('not approval or verification or finance or pm', action);
    return true;
  };

  return (
    <GlobalDialog
      maxWidth={'md'}
      fullWidth
      title={'Approve / Reject / View Refund Request'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        open ? (
          loading || additionalLoading ? (
            <Loader3D />
          ) : (
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Stack gap={2}>
                  <FetchedStudentDetails studentData={studentData} />
                  <RequestInfo rowData={rowData} />
                  <Divider />
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: '1px solid #e0e0e0',
                      borderRadius: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom color="primary">
                      Attachments
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          sx={{
                            p: 1.5,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: '#fafafa',
                            transition: '0.2s',
                            '&:hover': {
                              backgroundColor: '#f0f8ff',
                            },
                          }}
                        >
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography
                              variant="body2"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Refund Attachement
                            </Typography>
                          </Stack>
                          {/* <GlobalViewAttachment
                            attachmentFileName={rowData?.attachmentUrl}
                            previewButtonName={'View'}
                          /> */}
                          <GlobalAllTypeFileView
                            previewButtonName={'View'}
                            attachmentFiles={[rowData?.attachmentUrl]}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <Box
                          sx={{
                            p: 1.5,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: '#fafafa',
                            transition: '0.2s',
                            '&:hover': {
                              backgroundColor: '#f0f8ff',
                            },
                          }}
                        >
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography
                              variant="body2"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Parent Attachement
                            </Typography>
                          </Stack>
                          {/* <GlobalViewAttachment
                            attachmentFileName={rowData?.parent_connection_attachmentUrl}
                            previewButtonName={'View'}
                          /> */}
                          <GlobalAllTypeFileView
                            previewButtonName={'View'}
                            attachmentFiles={[rowData?.parent_connection_attachmentUrl]}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>

                  <RefundCalculation refundData={refundCalculation} finalRefundAmount={rowData?.expense_amount} />

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      bgcolor: '#f5f5f5', // light gray background
                      p: 1.5,
                      borderRadius: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: 15 }}>Current Status</Typography>

                    <Chip
                      label={rowData?.display_status || 'Unknown Status'}
                      color="primary"
                      variant="outlined"
                      sx={{
                        fontWeight: 600,
                        fontSize: 14,
                        px: 1.5,
                        borderWidth: 2,
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      bgcolor: '#f5f5f5', // light gray background
                      p: 1.5,
                      borderRadius: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: 15 }}>Action Type</Typography>

                    <Chip
                      label={(() => {
                        const actionType =
                          action === 'verify'
                            ? 'Verification'
                            : action === 'approval'
                              ? 'Approval'
                              : action === 'pm'
                                ? 'PM Approval'
                                : action === 'finance'
                                  ? 'Finance Approval'
                                  : 'View Only';

                        return actionType;
                      })()}
                    />
                  </Box>

                  {hasActions && (
                    <Box>
                      <Stack gap={2}>
                        <GlobalSelectField
                          options={{
                            formik: formik,
                            label: 'Approval Status',
                            name: 'status',
                            data: action === 'finance' ? [...status, { id: 3, name: 'Hold' }] : status,
                            keys: {
                              id: 'id',
                              value: 'name',
                            },
                            sx: {
                              width: '100%',
                            },
                          }}
                        />
                        {formik.values.status === 1 && action == 'finance' && (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Scheduled Payment Date"
                              format="DD-MM-YYYY"
                              value={
                                formik.values.scheduled_payment_date
                                  ? dayjs(formik.values.scheduled_payment_date)
                                  : null
                              }
                              onChange={(value) =>
                                formik.setFieldValue('scheduled_payment_date', value?.format('YYYY-MM-DD'))
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error:
                                    formik.touched.scheduled_payment_date &&
                                    Boolean(formik.errors.scheduled_payment_date),
                                  helperText:
                                    formik.touched.scheduled_payment_date && formik.errors.scheduled_payment_date,
                                },
                              }}
                            />
                          </LocalizationProvider>
                        )}
                        {action == 'finance' && formik.values.status === 2 && (
                          <GlobalSelectField
                            options={{
                              formik: formik,
                              label: 'Rejection Reasons',
                              name: 'accountant_rejected_reason_id',
                              data: rejectionReasons,
                              keys: {
                                id: 'id',
                                value: 'name',
                              },
                              sx: {
                                width: '100%',
                              },
                            }}
                          />
                        )}
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={5}
                          label="Remarks"
                          name="remarks"
                          value={formik.values.remarks}
                          onChange={formik.handleChange}
                          error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                          helperText={formik.touched.remarks && formik.errors.remarks}
                        />
                      </Stack>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            sx={{ boxShadow: 'none' }}
                            color="secondary"
                            size="small"
                            variant="contained"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>

                          <Button
                            sx={{ boxShadow: 'none' }}
                            color="primary"
                            size="small"
                            variant="contained"
                            type="submit"
                            disabled={submitDisablingFunction() || submitionLoading}
                          >
                            {submitionLoading ? 'Submitting...' : 'Submit'}
                          </Button>
                        </Stack>
                      </Box>
                    </Box>
                  )}
                </Stack>
              </Form>
            </FormikProvider>
          )
        ) : null
      }
    />
  );
};

export default GlobalRefundApprovalReject;
